var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Chuyển đổi dữ liệu nhận xét",
        visible: _vm.dialogVisible,
        width: "700px",
        "before-close": _vm.closeDialog,
        "close-on-click-modal": false,
        top: "5vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "section",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.isLoading,
              expression: "isLoading",
            },
          ],
        },
        [
          _c(
            "div",
            { staticClass: "migration-card" },
            [
              _c("div", { staticClass: "card-sub-title" }, [
                _c("i", { staticClass: "el-icon-s-operation" }),
                _vm._v(" Thông tin chuyển đổi\n      "),
              ]),
              _c(
                "el-form",
                {
                  ref: "migrationForm",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-position": "top",
                    size: "small",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "Trường", prop: "schoolId" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "Chọn trường", filterable: "" },
                          model: {
                            value: _vm.form.schoolId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "schoolId", $$v)
                            },
                            expression: "form.schoolId",
                          },
                        },
                        _vm._l(_vm.schoolList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              value: item.id,
                              label: item.id + " - " + item.schoolName,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Loại nhận xét", prop: "type" } },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  on: { change: _vm.handleTypeChange },
                                  model: {
                                    value: _vm.form.type,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "type", $$v)
                                    },
                                    expression: "form.type",
                                  },
                                },
                                [
                                  _c(
                                    "el-radio-button",
                                    { attrs: { label: "daily" } },
                                    [_vm._v("Ngày")]
                                  ),
                                  _c(
                                    "el-radio-button",
                                    { attrs: { label: "weekly" } },
                                    [_vm._v("Tuần")]
                                  ),
                                  _c(
                                    "el-radio-button",
                                    { attrs: { label: "monthly" } },
                                    [_vm._v("Tháng")]
                                  ),
                                  _c(
                                    "el-radio-button",
                                    { attrs: { label: "periodic" } },
                                    [_vm._v("Định kỳ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.form.type === "daily"
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Tháng nhận xét",
                                    prop: "selectedMonth",
                                  },
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      type: "month",
                                      placeholder: "Chọn tháng",
                                      format: "MM/yyyy",
                                      "value-format": "yyyy-MM",
                                    },
                                    model: {
                                      value: _vm.form.selectedMonth,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "selectedMonth", $$v)
                                      },
                                      expression: "form.selectedMonth",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Năm nhận xét",
                                    prop: "selectedYear",
                                  },
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      type: "year",
                                      placeholder: "Chọn năm",
                                      format: "yyyy",
                                      "value-format": "yyyy",
                                    },
                                    model: {
                                      value: _vm.form.selectedYear,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "selectedYear", $$v)
                                      },
                                      expression: "form.selectedYear",
                                    },
                                  }),
                                ],
                                1
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "warning-note" }, [
                _c("i", { staticClass: "el-icon-warning-outline" }),
                _c("div", { staticClass: "warning-note-content" }, [
                  _c("div", [
                    _vm._v(
                      "Dữ liệu nhận xét mới đã tồn tại sẽ được bỏ qua, không ghi đè."
                    ),
                  ]),
                  _vm.form.type === "daily"
                    ? _c("div", { staticClass: "period-note" }, [
                        _vm._v(
                          "\n            Chọn một tháng; hệ thống sẽ chuyển đổi từ ngày đầu đến ngày cuối tháng.\n          "
                        ),
                      ])
                    : _c("div", { staticClass: "period-note" }, [
                        _vm._v(
                          "\n            Chọn một năm; hệ thống sẽ chuyển đổi trong phạm vi cả năm.\n          "
                        ),
                      ]),
                ]),
              ]),
            ],
            1
          ),
          _vm.result !== null
            ? _c("div", { staticClass: "migration-card" }, [
                _c("div", { staticClass: "card-sub-title" }, [
                  _c("i", { staticClass: "el-icon-data-analysis" }),
                  _vm._v(" Kết quả chuyển đổi\n      "),
                ]),
                _c("div", { staticClass: "result-summary" }, [
                  _c("div", { staticClass: "summary-box total" }, [
                    _c("span", { staticClass: "num" }, [
                      _vm._v(_vm._s(_vm.result.sourceCount)),
                    ]),
                    _c("span", { staticClass: "lbl" }, [
                      _vm._v("Tổng bản ghi"),
                    ]),
                  ]),
                  _c("div", { staticClass: "summary-box skipped" }, [
                    _c("span", { staticClass: "num" }, [
                      _vm._v(_vm._s(_vm.result.skippedCount)),
                    ]),
                    _c("span", { staticClass: "lbl" }, [_vm._v("Bỏ qua ⏭️")]),
                  ]),
                  _c("div", { staticClass: "summary-box success" }, [
                    _c("span", { staticClass: "num" }, [
                      _vm._v(_vm._s(_vm.result.insertedCount)),
                    ]),
                    _c("span", { staticClass: "lbl" }, [_vm._v("Đã lưu ✅")]),
                  ]),
                  _c("div", { staticClass: "summary-box failed" }, [
                    _c("span", { staticClass: "num" }, [
                      _vm._v(_vm._s(_vm.result.failedCount)),
                    ]),
                    _c("span", { staticClass: "lbl" }, [_vm._v("Lỗi ❌")]),
                  ]),
                ]),
                _c("div", { staticClass: "result-legend" }, [
                  _c("div", { staticClass: "legend-title" }, [
                    _c("i", { staticClass: "el-icon-info" }),
                    _c("span", [_vm._v("Chú thích")]),
                  ]),
                  _c("div", { staticClass: "legend-item" }, [
                    _c("strong", [_vm._v("Tổng bản ghi:")]),
                    _vm._v(
                      "\n          tổng số bản ghi nhận xét tìm thấy theo trường và thời gian đã chọn.\n        "
                    ),
                  ]),
                  _c("div", { staticClass: "legend-item" }, [
                    _c("strong", [_vm._v("Đã lưu:")]),
                    _vm._v(
                      "\n          số bản ghi đã chuyển đổi và lưu thành công vào dữ liệu mới.\n        "
                    ),
                  ]),
                  _c("div", { staticClass: "legend-item" }, [
                    _c("strong", [_vm._v("Bỏ qua:")]),
                    _vm._v(
                      "\n          số bản ghi không được ghi thêm, thường do đã tồn tại hoặc không có nội dung nhận xét.\n        "
                    ),
                  ]),
                  _c("div", { staticClass: "legend-item" }, [
                    _c("strong", [_vm._v("Lỗi:")]),
                    _vm._v(
                      "\n          số bản ghi chuyển đổi thất bại, cần kiểm tra lại để xử lý.\n        "
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
        ]
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "danger", size: "medium" },
              on: { click: _vm.closeDialog },
            },
            [
              _c("i", { staticClass: "el-icon-circle-close" }),
              _vm._v(" Đóng\n    "),
            ]
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                size: "medium",
                loading: _vm.isLoading,
              },
              on: { click: _vm.handleMigrate },
            },
            [
              _c("i", { staticClass: "el-icon-refresh" }),
              _vm._v(" Chuyển đổi\n    "),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }